import { render } from "./ArticleSimpleList.vue?vue&type=template&id=13b1ca71"
import script from "./ArticleSimpleList.vue?vue&type=script&lang=js"
export * from "./ArticleSimpleList.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ArticleSimpleList.vue?vue&type=style&index=0&id=13b1ca71&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/times/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__